export default "__VITE_ASSET__CJjjSmvi__"